<template>
  <div style="display: flex; align-items: center">
    <div v-if="isDialog">
      <el-button type="text" @click="dialogVisible = true">
        {{ $t('system::tip::upload_attachment') }}
        <span v-show="currentVal.length">（已上传{{ currentVal.length }}个）</span>
      </el-button>
      <el-dialog title="" v-bind="$attrs" :visible.sync="dialogVisible">
        <div class="dialog-wrap">
          <el-upload
            ref="upload"
            action=""
            custom-class="dialog-wrap"
            drag
            :file-list="currentVal"
            :limit="limit"
            :before-upload="customUpload"
            :on-remove="removeFile"
            :on-exceed="exceed"
            :show-file-list="false"
            v-bind="{ ...$attrs }"
            v-on="{ ...$listeners }"
          >
            <div class="upload_wrap" v-if="currentVal && currentVal.length">
              <div class="list-wrap" v-for="item in currentVal" :key="item.url">
                <p>{{ item.name }}</p>
                <i class="el-icon-close" @click.stop="removeItem(item)"></i>
              </div>
            </div>
            <div class="upload_wrap" v-else>
              <i class="el-icon-plus"></i>
              <el-button class="add-file-btn">{{ $t('system::tip::upload_click') }}</el-button>
              <span>{{ $t('system::tip::upload_drag_tip') }}</span>
            </div>
            <div class="el-upload__tip" slot="tip">
              {{
                $t('system::tip::upload_limit_tip_new', {
                  limit: limit,
                  accept: accept
                })
              }}
            </div>
          </el-upload>
        </div>
      </el-dialog>
    </div>
    <el-upload
      v-else
      ref="upload"
      action=""
      drag
      :file-list="currentVal"
      :limit="limit"
      :before-upload="customUpload"
      :on-remove="removeFile"
      :on-exceed="exceed"
      :show-file-list="false"
      v-bind="{ ...$attrs }"
      v-on="{ ...$listeners }"
    >
      <div class="upload_wrap" v-if="currentVal && currentVal.length">
        <div class="list-wrap" v-for="item in currentVal" :key="item.url">
          <p>{{ item.name }}</p>
          <i class="el-icon-close" @click.stop="removeItem(item)"></i>
        </div>
      </div>
      <div class="upload_wrap" v-else>
        <i class="el-icon-plus"></i>
        <el-button class="add-file-btn">{{ $t('system::tip::upload_click') }}</el-button>
        <span>{{ $t('system::tip::upload_drag_tip') }}</span>
      </div>
      <div class="el-upload__tip" slot="tip">
        {{
          $t('system::tip::upload_limit_tip_new', {
            limit: limit,
            accept: accept
          })
        }}
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getUpload } from '@/server/product'
import * as qiniu from 'qiniu-js'
const FILE_SIZE_RATE = 1024
export default {
  name: 'ZUpload',
  data() {
    return {
      currentVal: this.value,
      dialogVisible: false
    }
  },
  props: {
    value: {},
    fileSize: {
      type: Number,
      default: 10
    }, // 限制大小，单位MB
    limit: {
      type: Number,
      default: 5
    },
    accept: {
      type: String,
      default: 'png,jpg,xlsx,xls'
    },
    isDialog: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log(this.$attrs, 'arr')
  },
  methods: {
    // 附件上传
    customUpload(file) {
      const typeList = this.accept.split(',')
      const valid = typeList.some(i => file.name.toLowerCase().endsWith(i))
      if (!valid) {
        this.$message.warning(this.$t('system::tip::accept_file', { accept: this.accept }))
        return false
      }
      if (this.fileSize && this.fileSize * FILE_SIZE_RATE * FILE_SIZE_RATE < file.size) {
        this.$message.warning(this.$t('system::tip::fileSize_limit', { fileSize: this.fileSize }))
        return false
      }
      getUpload({
        type: 'common',
        file_name: file.name
      }).then(res => {
        if (res.data.code === this.$code) {
          const { path, token, qiniuDomain } = res.data.data
          const putExtra = {
            fname: file.name
          }
          const config = {
            useCdnDomain: true
          }
          // 图片上传
          //  实例化七牛云的上传实例
          const observable = qiniu.upload(file, path, token, putExtra, config)

          //   设置实例的监听对象
          const observer = {
            //   接收上传进度信息
            next(res) {
              // 上传进度
            },
            // 接收上传错误信息
            // eslint-disable-next-line handle-callback-err
            error(err) {
              console.log(err)
            },

            // 接收上传完成后的信息
            complete: res => {
              // 拼接路径字符串
              const fileUrl = `${qiniuDomain}${res.key}`
              this.currentVal = [...this.currentVal, { name: file.name, url: fileUrl, fileSize: file.size }]
            }
          }

          const subscription = observable.subscribe(observer) // 上传开始
        }
      })
      return false
    },
    removeFile(file, fileList) {
      this.currentVal = fileList
    },
    exceed() {
      this.$message.warning(this.$t('system::tip::limit', { limit: this.limit }))
    },
    removeItem(item) {
      this.$refs.upload.handleRemove(item)
    }
  },
  watch: {
    currentVal(val) {
      this.$emit('input', val)
    },
    value(value) {
      this.currentVal = value
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  display: flex;
  justify-content: center;
}
/deep/.el-dialog__header {
  border-bottom: none;
}
/deep/.el-dialog__headerbtn {
  z-index: 10;
}
/deep/.el-upload__tip {
  color: #999999;
  line-height: 1;
  margin-top: -7px;
}
.upload_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  line-height: 1;
  background: #f5f6f8;
  .el-icon-plus {
    font-size: 24px;
    color: #666666;
  }
  .add-file-btn {
    margin: 8px 0;
  }
  span {
    color: #999999;
  }
  .list-wrap {
    width: 200px;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    i {
      font-size: 20px;
    }
  }
}
</style>
